export default {
  'confirm-yes': 'Sim, confirmo',
  copay: 'Coparticipação:',
  cancel: 'Cancelar',
  'order-status': 'Status do pedido:',
  'order-canceled': 'Pedido cancelado',
  'confirmed-back-to-pharmacy': 'Devolução à farmácia confirmada',
  'on-its-way-to-pharmacy': 'A caminho da farmácia',
  'back-to-pharmacy': 'Devolvido à farmácia',
  'patient-signature': 'Assinatura do paciente',
  sign: 'Assinar',
  'select-order-type': 'Selecionar tipo de pedido',
  'preferred-eta': 'Horário de entrega preferido',
  'recipient-instructions': 'Instruções especiais do destinatário',
  'add-special-instruction': 'Adicionar instrução especial',
  'unable-to-change-address': 'Não foi possível alterar o endereço',
  'address-changed': 'Endereço alterado com sucesso',
  'start-typing': 'Comece a digitar',
  'full-address': 'Endereço completo',
  'street-address': 'Logradouro',
  zip: 'CEP',
  city: 'Cidade',
  state: 'Estado',
  apt: 'Apto',
  'app-store': 'Baixar na App Store',
  'track-all-orders': 'Acompanhe todos os seus pedidos em um só app',
  zoom: 'ampliar',
  unzoom: 'reduzir',
  'close-photo': 'fechar',
  'feedback-call': 'Ligação',
  'feedback-message': 'Mensagem',
  'feedback-close': 'Fechar',
  close: 'Fechar',
}
